/* eslint-disable camelcase */
import api from './axios'

export interface LoginPayload {
  email: string
  password: string
}

export interface RegisterPayload {
  first_name: string
  last_name: string
  agency_name: string
  license_number: string
  email: string
  phone: string
  password: string
  password_confirmation: string
}

export interface AuthUser {
  id: number
  first_name: string
  last_name: string
  agency_name: string
  email: string
  role: 'agent' | 'admin'
  status: 'pending' | 'active' | 'suspended'
  avatar_url: string | null
}

export interface LoginResponse {
  access_token: string
  refresh_token: string
  token_type: string
  expires_in: number
  user: AuthUser
}

export const authApi = {
  login (payload: LoginPayload) {
    return api.post<LoginResponse>('/auth/login', payload)
  },

  register (payload: RegisterPayload) {
    return api.post<{ message: string }>('/auth/register', payload)
  },

  logout (role: 'agent' | 'admin') {
    return api.post<{ message: string }>(`/${role}/auth/logout`)
  },

  refresh (refreshToken: string) {
    return api.post<{ access_token: string; expires_in: number }>('/auth/refresh', {
      refresh_token: refreshToken
    })
  },

  forgotPassword (email: string) {
    return api.post<{ message: string }>('/auth/forgot-password', { email })
  },

  resetPassword (payload: { token: string; email: string; password: string; password_confirmation: string }) {
    return api.post<{ message: string }>('/auth/reset-password', payload)
  }
}
